/** @jsxImportSource react */
import { useState } from 'react'
import { Button, ListSubheader, Menu, MenuItem } from '@mui/material'
import DataObjectIcon from '@mui/icons-material/DataObject'

/** Adds a {{placeholder}} to a text template: record title, who changed it, or any field. */
const InsertFieldMenu = ({ fields, onInsert, timeBased = false }) => {
  const [anchor, setAnchor] = useState(null)
  const pick = (key) => { setAnchor(null); onInsert(`{{${key}}}`) }
  return (
    <>
      <Button size="small" startIcon={<DataObjectIcon />} onClick={(e) => setAnchor(e.currentTarget)}>Insert field</Button>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} PaperProps={{ sx: { maxHeight: 360 } }}>
        <MenuItem onClick={() => pick('record.title')}>Record title</MenuItem>
        {!timeBased && <MenuItem onClick={() => pick('actor.email')}>Who made the change</MenuItem>}
        <ListSubheader>Fields</ListSubheader>
        {fields.map((f) => <MenuItem key={f.fieldKey} onClick={() => pick(f.fieldKey)}>{f.label}</MenuItem>)}
      </Menu>
    </>
  )
}

export default InsertFieldMenu
